import React from "react";
import PulseSelectButton from "../../PulseSelectButton/PulseSelectButton";

interface Step4ConfigurationPropsiOS {
  programmingLanguage: string;
  uiEntryPoint: string;
  usesScenes: string;
  onUpdateState: (
    field: "programmingLanguage" | "uiEntryPoint" | "usesScenes",
    value: string,
  ) => void;
}

const Step4ConfigurationiOS: React.FC<Step4ConfigurationPropsiOS> = ({
  programmingLanguage,
  uiEntryPoint,
  usesScenes,
  onUpdateState,
}) => {
  return (
    <>
      <h1 className="pl-heading-xl">Install SDK</h1>
      <div className="step-content">
        <div className="select-group">
          <h2 className="pl-heading-s">What language will you be using?</h2>
          <div className="side-by-side-buttons">
            <PulseSelectButton
              options={[
                { label: "SWIFT", value: "swift" },
                { label: "OBJECTIVE-C", value: "objective-c" },
              ]}
              value={programmingLanguage}
              onChange={(value) => onUpdateState("programmingLanguage", value)}
            />
          </div>
        </div>

        {programmingLanguage === "swift" && (
          <div className="select-group">
            <h2 className="pl-heading-s">
              Which UI will you be using as the main entry point?
            </h2>
            <div className="side-by-side-buttons">
              <PulseSelectButton
                options={[
                  { label: "SWIFT UI", value: "SwiftUi" },
                  { label: "UI KIT", value: "UIKit" },
                ]}
                value={uiEntryPoint}
                onChange={(value) => onUpdateState("uiEntryPoint", value)}
              />
            </div>
          </div>
        )}

        {((uiEntryPoint && uiEntryPoint === "UIKit") ||
          programmingLanguage === "objective-c") && (
          <div className="select-group">
            <h2 className="pl-heading-s">Will you be using scenes?</h2>
            <div className="side-by-side-buttons">
              <PulseSelectButton
                options={[
                  { label: "YES", value: "Yes" },
                  { label: "NO", value: "No" },
                ]}
                value={usesScenes}
                onChange={(value) => onUpdateState("usesScenes", value)}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Step4ConfigurationiOS;
